<table border="1" cellborder="1" width="100%">
   <tr>
      <td></td>
      <ng-container *ngFor="let col of Object.keys(players); let i = index">
         <td align="center" [ngClass]="{'winner-col': i == winnercol}">
            {{players[col].firstName}} {{players[col].lastName[0]}}
         </td>
      </ng-container>
   </tr>
   <tr *ngFor="let row of Object.keys(players)">
      <td nowrap style="padding: 0 8px;">
         {{players[row].firstName}} {{players[row].lastName[0]}}
      </td>
      <ng-container *ngFor="let col of Object.keys(players); let i = index">
         <td width="10%" align="center" [ngClass]="{'xxx': grid[row][i] == 'X', 'winner-col': i == winnercol}">
            {{grid[row][i]}}
         </td>
      </ng-container>
   </tr>
   <tr style="font-weight: bold; font-size: 125%">
     <td></td>
      <ng-container *ngFor="let x of total; let i = index">
        <td width="10%" align="center" [ngClass]="{'winner': i == winnercol, 'total': i != winnercol}">
          {{x}}
        </td>
      </ng-container>
   </tr>

</table>
